/** Hujjat holati nuqtasi: yashil -- bor, sariq-jigarrang -- so'ralgan yoki tugayapti, qizil -- muddati tugagan, bo'sh -- yo'q */
import { AlertTriangle, Check, Clock3 } from "lucide-react";
import { cn } from "@/lib/utils";
import type { DocumentStatus } from "@/features/documents/types";

export function StatusDot({ status, size = "md" }: { status: DocumentStatus; size?: "md" | "sm" }) {
  const base = cn("grid shrink-0 place-items-center rounded-full border-[1.5px]", size === "md" ? "h-6 w-6" : "h-3 w-3");
  const icon = size === "md";
  switch (status) {
    case "received":
      return (
        <span className={cn(base, "border-success bg-success text-white")} aria-hidden>
          {icon && <Check size={13} strokeWidth={3} />}
        </span>
      );
    case "expiring":
      return (
        <span className={cn(base, "border-warning bg-warning text-white")} aria-hidden>
          {icon && <Check size={13} strokeWidth={3} />}
        </span>
      );
    case "expired":
      return (
        <span className={cn(base, "border-danger bg-danger text-white")} aria-hidden>
          {icon && <AlertTriangle size={12} strokeWidth={2.5} />}
        </span>
      );
    case "requested":
      return (
        <span className={cn(base, "border-warning text-warning")} aria-hidden>
          {icon && <Clock3 size={12} strokeWidth={2.5} />}
        </span>
      );
    default:
      return <span className={cn(base, "border-border")} aria-hidden />;
  }
}
